import axios from "axios";
import { isPublicUrl } from "Shared/utils/isPublicUrl";

const KeepAlive = {
  install(Vue, options = {}) {
    if (!options.url) {
      throw new Error("KeepAlive requires a URL");
    }

    if (!options.timeout) {
      options.timeout = 10;
    }

    setInterval(function () {
      if (!isPublicUrl()) {
        axios.get(options.url);
      }
    }, options.timeout * 60 * 1000);
  },
};

export default KeepAlive;
